// extracted by mini-css-extract-plugin
module.exports = {"similar__button":"styles_similar__button__xxOTd","similar__toggle":"styles_similar__toggle__GjDKh"};